import * as actionTypes from '../actions/actionTypes';
import {
    updateObject
} from '../../shared/utility';


const initialState = {
    IOTssidNetwork: {},
    IOTssidNetworkSuccess: false,
    IOTssidNetworkFail: false,
    IOTssidNetworkLoading: false,
    IOTssidFailureMesssage: '',
    IOTssidNetworkSuccessMessage: '',
    createIOTssidNetworkFailed: false,
    createIOTssidNetworkSuccess: false,
    IOTssidNetworkFailMsg: "",
    networks: [],
    networksLoading: false,
    networksLoaded: false,
    networksError: false,
    selectedNetwork: null,
    networkDevices: [],
    networkDevicesLoading: false,
    networkDevicesLoaded: false,
    networkDevicesError: false,
    updateNetworkLoading: false,
    updateNetworkSuccess: false,
    updateNetworkError: false,
    deleteNetworkLoading: false,
    deleteNetworkSuccess: false,
    deleteNetworkError: false,
    // Guest Network Session
    guestSession: null,
    guestSessionLoading: false,
    guestSessionError: null,
    updateGuestSessionLoading: false,
    updateGuestSessionSuccess: false,
    updateGuestSessionError: null,
    guestSessionPolling: false,
    // Guest Network Schedule
    guestSchedule: null,
    guestScheduleLoading: false,
    guestScheduleError: null,
    guestSchedulePolling: false,
    updateGuestScheduleLoading: false,
    updateGuestScheduleSuccess: false,
    updateGuestScheduleError: null,
    // Network Device Pause
    devicePauseState: null,
    devicePauseStateLoading: false,
    devicePauseStateError: null,
    pauseNetworkDeviceLoading: false,
    pauseNetworkDeviceSuccess: false,
    pauseNetworkDeviceError: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.CREATE_IOT_SSID_NETWORK_LOADING:
            return updateObject(state, {
                createIOTssidNetwork: {},
                createIOTssidNetworkLoading: action.isLoading,
            });
            
        case actionTypes.CREATE_IOT_SSID_NETWORK_SUCCESS:
            return updateObject(state, {
                createIOTssidNetwork: action.payload?.network || {},
                createIOTssidNetworkLoading: false,
                createIOTssidNetworkFailed: false,
                createIOTssidNetworkSuccess: true,
            });

        case actionTypes.CREATE_IOT_SSID_NETWORK_FAILED:
            return updateObject(state, {
                createIOTssidNetwork: {},
                createIOTssidNetworkFailed: true,
                createIOTssidNetworkLoading: false,
                createIOTssidNetworkSuccess: false,
                IOTssidNetworkFailMsg: action.payload?.message
            });
        case actionTypes.GET_IOT_SSID_NETWORK_LOADING:
            return updateObject(state, {
                createIOTssidNetwork: {},
                createIOTssidNetworkLoading: action.isLoading
                }); 

        case actionTypes.GET_IOT_SSID_NETWORK_SUCCESS:
            return updateObject(state, {
                getIOTssidNetwork: action.payload || {},
                getIOTssidNetworkLoading: false,
                getIOTssidNetworkSuccess: true,
                });

         case actionTypes.GET_IOT_SSID_NETWORK_FAILED:
             return updateObject(state, {
                getIOTssidNetwork: {},
                getIOTssidNetworkFail: true,
                getIOTssidNetworkSuccess: false,
                getIOTssidNetworkError: action.payload || true,
             }); 
        case actionTypes.GET_IOT_SSID_NETWORK_DEVICES_FAILED:
            return updateObject(state, {
                getIOTssidNetworkDevices: {},
                getIOTssidNetworkDevicesFail: true,
                getIOTssidNetworkDevicesSuccess: false,
                getIOTssidNetworkDevicesError: action.payload || true,
            });
        case actionTypes.GET_IOT_SSID_NETWORK_DEVICES_SUCCESS:
            return updateObject(state, {
                getIOTssidNetworkDevices: action.payload || {},
                getIOTssidNetworkDevicesFail: false,
                getIOTssidNetworkDevicesSuccess : false,
            });

        case actionTypes.GET_ALL_IOT_SSID_NETWORK_DETAILS_LOADING:
            return updateObject(state, {
                IOTssidNetwork: {},
                IOTssidNetworkLoading: action.isLoading
                }); 

        case actionTypes.RESET_IOT_SSID_ERROR_SUCCESS:
                    return updateObject(state , {
                        IOTSsidNetworkSuccess: false,
                        IOTSsidNetworkFail: false,
                        IOTSsidNetworkSuccessMessage: '',
                        IOTSsidDeleteFailureMesssage: '',
                        IOTSsidFailureMesssage: '',
                        createIOTssidNetworkFailed: false,
                        createIOTssidNetworkSuccess: false
                        });

        // Networks
        case actionTypes.GET_NETWORKS_LOADING:
            return updateObject(state, { networksLoading: true, networksLoaded: false, networksError: false });
        case actionTypes.GET_NETWORKS_SUCCESS:
            return updateObject(state, { networksLoading: false, networksLoaded: true, networksError: false, networks: action.payload });
        case actionTypes.GET_NETWORKS_FAIL:
            return updateObject(state, { networksLoading: false, networksLoaded: false, networksError: action.payload || true });
        case actionTypes.SET_SELECTED_NETWORK:
            return updateObject(state, { selectedNetwork: action.payload, networkDevices: [] });
        case actionTypes.GET_NETWORK_DEVICES_LOADING:
            return updateObject(state, { networkDevicesLoading: true, networkDevicesLoaded: false, networkDevicesError: false });
        case actionTypes.GET_NETWORK_DEVICES_SUCCESS:
            return updateObject(state, { networkDevicesLoading: false, networkDevicesLoaded: true, networkDevicesError: false, networkDevices: action.payload });
        case actionTypes.GET_NETWORK_DEVICES_FAIL:
            return updateObject(state, { networkDevicesLoading: false, networkDevicesLoaded: false, networkDevicesError: action.payload || true, networkDevices: [] });
        case actionTypes.UPDATE_NETWORK_LOADING:
            return updateObject(state, { updateNetworkLoading: true, updateNetworkSuccess: false, updateNetworkError: false });
        case actionTypes.UPDATE_NETWORK_SUCCESS: {
            const { wifiType, wifiSsidName, wifiSsidPassphrase, broadcast } = action.payload;
            const ssidFields = { wifiSsidName, broadcast };
            if (wifiSsidPassphrase !== undefined) ssidFields.wifiSsidPassphrase = wifiSsidPassphrase;
            const updatedNetworks = state.networks
                ? Object.keys(state.networks).reduce((acc, key) => {
                    const n = state.networks[key];
                    if (!isNaN(key) && n && n.wifiType === wifiType) {
                        acc[key] = { ...n, ...ssidFields };
                    } else {
                        acc[key] = n;
                    }
                    return acc;
                }, {})
                : state.networks;
            const updatedSelected = state.selectedNetwork?.wifiType === wifiType
                ? { ...state.selectedNetwork, ...ssidFields }
                : state.selectedNetwork;
            return updateObject(state, {
                updateNetworkLoading: false,
                updateNetworkSuccess: true,
                updateNetworkError: false,
                networks: updatedNetworks,
                selectedNetwork: updatedSelected,
                networkDevices: [],
                networkDevicesLoaded: false,
                networkDevicesError: false,
            });
        }
        case actionTypes.UPDATE_NETWORK_FAIL:
            return updateObject(state, { updateNetworkLoading: false, updateNetworkSuccess: false, updateNetworkError: action.payload || true });
        case actionTypes.CLEAR_UPDATE_NETWORK_ERROR:
            return updateObject(state, { updateNetworkError: false });
        case actionTypes.DELETE_NETWORK_LOADING:
            return updateObject(state, { deleteNetworkLoading: true, deleteNetworkSuccess: false, deleteNetworkError: false });
        case actionTypes.DELETE_NETWORK_SUCCESS:
            return updateObject(state, { deleteNetworkLoading: false, deleteNetworkSuccess: true, deleteNetworkError: false, selectedNetwork: null, networkDevices: [] });
        case actionTypes.DELETE_NETWORK_FAIL:
            return updateObject(state, { deleteNetworkLoading: false, deleteNetworkSuccess: false, deleteNetworkError: action.payload || true });

        // Guest Network Session
        case actionTypes.GET_GUEST_NETWORK_SESSION_LOADING:
            return updateObject(state, { guestSessionLoading: true, guestSessionError: null });
        case actionTypes.GET_GUEST_NETWORK_SESSION_SUCCESS:
            return updateObject(state, { guestSessionLoading: false, guestSession: action.payload, guestSessionError: null });
        case actionTypes.GET_GUEST_NETWORK_SESSION_FAIL:
            return updateObject(state, { guestSessionLoading: false, guestSessionError: action.payload || true });
        case actionTypes.UPDATE_GUEST_NETWORK_SESSION_LOADING:
            return updateObject(state, { updateGuestSessionLoading: true, updateGuestSessionSuccess: false, updateGuestSessionError: null });
        case actionTypes.UPDATE_GUEST_NETWORK_SESSION_SUCCESS:
            return updateObject(state, { updateGuestSessionLoading: false, updateGuestSessionSuccess: true, updateGuestSessionError: null, guestSession: action.payload });
        case actionTypes.UPDATE_GUEST_NETWORK_SESSION_FAIL:
            return updateObject(state, { updateGuestSessionLoading: false, updateGuestSessionSuccess: false, updateGuestSessionError: action.payload || true });
        case actionTypes.SET_GUEST_SESSION_POLLING:
            return updateObject(state, { guestSessionPolling: action.payload });

        // Guest Network Schedule
        case actionTypes.GET_GUEST_NETWORK_SCHEDULE_LOADING:
            return updateObject(state, { guestScheduleLoading: true, guestScheduleError: null });
        case actionTypes.GET_GUEST_NETWORK_SCHEDULE_SUCCESS:
            return updateObject(state, { guestScheduleLoading: false, guestSchedule: action.payload, guestScheduleError: null });
        case actionTypes.GET_GUEST_NETWORK_SCHEDULE_FAIL:
            return updateObject(state, { guestScheduleLoading: false, guestScheduleError: action.payload || true });
        case actionTypes.UPDATE_GUEST_NETWORK_SCHEDULE_LOADING:
            return updateObject(state, { updateGuestScheduleLoading: true, updateGuestScheduleSuccess: false, updateGuestScheduleError: null });
        case actionTypes.UPDATE_GUEST_NETWORK_SCHEDULE_SUCCESS:
            return updateObject(state, { updateGuestScheduleLoading: false, updateGuestScheduleSuccess: true, updateGuestScheduleError: null, guestSchedule: action.payload });
        case actionTypes.UPDATE_GUEST_NETWORK_SCHEDULE_FAIL:
            return updateObject(state, { updateGuestScheduleLoading: false, updateGuestScheduleSuccess: false, updateGuestScheduleError: action.payload || true });
        case actionTypes.CLEAR_GUEST_NETWORK_ERROR:
            return updateObject(state, { updateGuestSessionError: null, updateGuestSessionSuccess: false, updateGuestScheduleError: null, updateGuestScheduleSuccess: false });

        // Network Device Pause
        case actionTypes.GET_NETWORK_DEVICE_PAUSE_STATE_LOADING:
            return updateObject(state, { devicePauseStateLoading: true, devicePauseStateError: null });
        case actionTypes.GET_NETWORK_DEVICE_PAUSE_STATE_SUCCESS:
            return updateObject(state, { devicePauseStateLoading: false, devicePauseState: action.payload, devicePauseStateError: null });
        case actionTypes.GET_NETWORK_DEVICE_PAUSE_STATE_FAIL:
            return updateObject(state, { devicePauseStateLoading: false, devicePauseStateError: action.payload || true });
        case actionTypes.CLEAR_DEVICE_PAUSE_STATE_ERROR:
            return updateObject(state, { devicePauseStateError: null });
        case actionTypes.CLEAR_PAUSE_NETWORK_DEVICE_ERROR:
            return updateObject(state, { pauseNetworkDeviceError: null });
        case actionTypes.PAUSE_NETWORK_DEVICE_LOADING:
            return updateObject(state, { pauseNetworkDeviceLoading: true, pauseNetworkDeviceSuccess: false, pauseNetworkDeviceError: null });
        case actionTypes.PAUSE_NETWORK_DEVICE_SUCCESS:
            return updateObject(state, { pauseNetworkDeviceLoading: false, pauseNetworkDeviceSuccess: true, pauseNetworkDeviceError: null });
        case actionTypes.PAUSE_NETWORK_DEVICE_FAIL:
            return updateObject(state, { pauseNetworkDeviceLoading: false, pauseNetworkDeviceSuccess: false, pauseNetworkDeviceError: action.payload || true });
        case actionTypes.UNPAUSE_NETWORK_DEVICE_SUCCESS:
            return updateObject(state, { pauseNetworkDeviceLoading: false, pauseNetworkDeviceSuccess: true, pauseNetworkDeviceError: null });
        case actionTypes.UNPAUSE_NETWORK_DEVICE_FAIL:
            return updateObject(state, { pauseNetworkDeviceLoading: false, pauseNetworkDeviceSuccess: false, pauseNetworkDeviceError: action.payload || true });

        default: return state;
    }
};
export default reducer;
